import _toConsumableArray from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export var getNavData = function getNavData(shops) {
  var seasonalNav = [];
  var todaysDeals = undefined;
  var clubItem = undefined;

  var primaryNav = _toConsumableArray(shops).filter(function (shop) {
    if (shop.slug === "today-s-deals") {
      todaysDeals = shop;
      return false;
    }

    if (shop.slug === "club-catch") {
      clubItem = shop;
      return false;
    }

    if (shop.pinToTop) {
      seasonalNav.push(shop);
      return false;
    }

    return shop.shopNavigationGroups.length > 0;
  });

  if (todaysDeals) {
    seasonalNav.unshift(todaysDeals);
  }

  if (clubItem) {
    seasonalNav.unshift(clubItem);
  }

  return {
    primaryNav: primaryNav,
    seasonalNav: seasonalNav
  };
};